var _path, _path2, _g, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHandleOrder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M7.91666 13H5.41667C5.18655 13 5 13.1865 5 13.4167V14.25C5 14.4801 5.18655 14.6667 5.41667 14.6667H7.91666C8.14678 14.6667 8.33333 14.4801 8.33333 14.25V13.4167C8.33333 13.1865 8.14678 13 7.91666 13Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8607 2L10.9923 2.00749C11.6425 2.08435 12.1494 2.72344 12.1494 3.5C12.1494 4.27656 11.6425 13.7923 10.9923 13.8691L10.8607 13.8766H6.43903C5.72684 13.8766 5.14941 4.32837 5.14941 3.5C5.14941 2.67163 5.72684 2 6.43903 2H10.8607Z",
    fill: "#FF5563"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: -2,
    y: -0.630859,
    width: 21.2993,
    height: 22.864
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2px)",
      clipPath: "url(#bgblur_0_9308_7351_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_9308_7351)",
    "data-figma-bg-blur-radius": 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2993 4.93377C15.2993 4.06965 14.5988 3.36914 13.7347 3.36914H3.56463C2.70051 3.36914 2 4.06965 2 4.93377V11.9746C2 15.4311 4.80203 18.2331 8.25851 18.2331H13.7347C14.5988 18.2331 15.2993 17.5326 15.2993 16.6685V4.93377Z",
    fill: "#FF5563",
    fillOpacity: 0.3
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.12939 11.5833H7.47633H5.12939Z",
    fill: "#FF3949",
    fillOpacity: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.12939 11.5833H7.47633",
    stroke: "white",
    strokeWidth: 1.17347,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.12939 8.06299H12.1702H5.12939Z",
    fill: "#FF3949",
    fillOpacity: 0.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.12939 8.06299H12.1702",
    stroke: "white",
    strokeWidth: 1.17347,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_9308_7351",
    x: -2,
    y: -0.630859,
    width: 21.2993,
    height: 22.864,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_9308_7351"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_9308_7351_clip_path",
    transform: "translate(2 0.630859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2993 4.93377C15.2993 4.06965 14.5988 3.36914 13.7347 3.36914H3.56463C2.70051 3.36914 2 4.06965 2 4.93377V11.9746C2 15.4311 4.80203 18.2331 8.25851 18.2331H13.7347C14.5988 18.2331 15.2993 17.5326 15.2993 16.6685V4.93377Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandleOrder);
export default __webpack_public_path__ + "static/media/handleOrder.927226ea7c922b8ae254f84b58bf40f4.svg";
export { ForwardRef as ReactComponent };